import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

export const initAmplitude = () => {
  try {
    amplitude.add(engagementPlugin());
    amplitude.init('19754ef38e60e737ec72fd90a67dbd54', { appVersion: _GIT_HASH_, autocapture: false });
  } catch (error) {
    console.error('Error initializing Amplitude', error);
  }
};
